import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';
import Translations from '@/utils/Translations';

import '@/filters.ts';
import '@/components.ts';

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

Vue.prototype.$l = 'sv';

Vue.prototype.$t = (term: string) => Translations.GetTranslation(term);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
